import React, { FC, useCallback, useEffect } from "react";
import ListBlock from "../common/F7/ListBlock";
import ListBlockItem from "../common/F7/ListBlockItem";
import Page from "../common/navigation/Page";
import style from "../../styles/tileDownloaderStyle";
import { useNavigate } from "react-router-dom";
import Button from "../common/F7/Button";
import { useOfflineMaps } from "../../hooks/useOfflineMaps";
import BackButton from "../common/navigation/BackButton";
import { useSetOfflineMapId } from "../../state";
import F7 from "../../utils/F7";

const OfflineMapsPage: FC = () => {
  useEffect(() => {
    F7.closePanel();
  }, []);

  const { downloads } = useOfflineMaps();

  const navigate = useNavigate();

  const setOfflineMapId = useSetOfflineMapId();

  const selectOfflineMap = useCallback(
    async (download: typeof downloads[number]) => {
      setOfflineMapId(download.id || null);

      navigate("../../");
    },
    [navigate, setOfflineMapId]
  );

  const css = style;

  return (
    <Page title="Offline Maps" navbarLeft={<BackButton />}>
      <div style={{ textAlign: "center" }}>
        <Button to="new" style={css.buttonConfirm}>
          Download
        </Button>
      </div>
      <ListBlock>
        {downloads.map((map) => (
          <ListBlockItem key={map.id} title={map.name} onClick={() => selectOfflineMap(map)} />
        ))}
      </ListBlock>
    </Page>
  );
};

export default OfflineMapsPage;
